import { ExpandableContentWrapper, ExpConcentrationChart } from 'components';
import { CanvasContentId, CanvasComponentConfig } from 'types/canvas';
import { IndexSymbol, IndexSymbols } from 'types';

interface CanvasExpConcentrationProps {
  config: CanvasComponentConfig;
  onConfigChange: (patch: Partial<CanvasComponentConfig>) => void;
}

const ALL_INDEX_SYMS: IndexSymbol[] = Array.from(IndexSymbols);
const VALID_INDEX_SYMS = new Set<string>(ALL_INDEX_SYMS);

const isIndexSymbol = (s: unknown): s is IndexSymbol =>
  typeof s === 'string' && VALID_INDEX_SYMS.has(s);

const CanvasExpConcentration = ({
  config,
  onConfigChange,
}: CanvasExpConcentrationProps) => {
  // Multi-symbol selection persisted in canvas config. Defaults to every
  // index when nothing is saved (matches the chart's homepage default).
  const persisted: unknown = config.syms;
  const selectedIndices: IndexSymbol[] = Array.isArray(persisted)
    ? persisted.filter(isIndexSymbol)
    : ALL_INDEX_SYMS;

  return (
    <ExpandableContentWrapper
      type={CanvasContentId.EXP_CONCENTRATION_CHART}
      styleOverrides={{ p: 1, height: '100%' }}
    >
      <ExpConcentrationChart
        // Multi-sym branch: selectedSym is unused, the chart fetches by
        // joining selectedIndices instead.
        selectedSym=""
        selectedIndices={selectedIndices}
        onSelectedIndicesChange={(next) => onConfigChange({ syms: next })}
      />
    </ExpandableContentWrapper>
  );
};

export default CanvasExpConcentration;
